export const SESSION_METADATA_ROUTES = {
  // GET /api/demo/session/{session_id}/metadata?session_token=...
  SESSION_METADATA: sessionId => `/demo/session/${encodeURIComponent(sessionId)}/metadata`,
};
